<mat-card>
  <mat-card-content>
    <span class="text-error">{{ message }}</span>
  </mat-card-content>
</mat-card>
